<template>
  <div class="tx-dealersearch module-google-map" ref="container">
    <div class="map-wrapper" ref="wrapper">
      <div :id="id" :ref="id">
      </div>
    </div>
  </div>
</template>

<script>
/* global google */
import { mapState } from 'vuex'

export default {
  name: 'GoogleMap',
  inject: ['apiBase', 'mobile', 'phone'],
  data () {
    return {
      map: null,
      mapBounds: {},
      markerIconPoi: {
        url: '',
        size: new google.maps.Size(44, 58),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(18, 58),
        scaledSize: new google.maps.Size(44, 58)
      },
      markerIconSearch: {
        url: '',
        size: new google.maps.Size(44, 58),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(18, 58),
        scaledSize: new google.maps.Size(44, 58)
      },
      searchMarker: null,
      searchPopup: null,
      markerClickPopups: [],
      lastClickedIndex: -1,
      defaultDealerPicURL: ''
    }
  },
  props: {
    id: {
      type: String,
      default: 'map'
    },
    hoveredPoiIndex: {
      type: Number,
      default: -1
    },
    clickedPoiIndex: {
      type: Number,
      default: -1
    }
  },
  computed: {
    ...mapState({
      moreLoaded: state => state.moreLoaded,
      pois: state => state.dealer.dealers,
      latitudeSearched: state => state.latitude,
      longitudeSearched: state => state.longitude
    })
  },
  watch: {
    pois: function (newPois) {
      const self = this
      self.$emit('closedPoiIndex')

      if (self.markers) {
        for (let i = 0; i < self.markers.length; i++) {
          self.markers[i].setMap(null)
        }
      }
      self.markers = []
      self.mapBounds = new google.maps.LatLngBounds()

      self.updateSearchMarker()

      if (newPois.length) {
        for (let i = 0; i < newPois.length; i++) {
          self.addMapMarker(self, newPois[i], i)
        }
        if (!self.bounds) {
          self.map.fitBounds(self.mapBounds)
        }
      } else {
        if (self.latitudeSearched && self.longitudeSearched) {
          self.map.setCenter({ lat: self.latitudeSearched, lng: self.longitudeSearched })
        } else {
          self.map.setCenter({ lat: 48.0532510192798, lng: 12.770071628931637 })
        }
        self.map.setZoom(13)
      }
    },
    hoveredPoiIndex: function (newHoveredPoi, oldHoveredPoi) {
      const self = this
      if (self && self.markers && oldHoveredPoi >= 0) {
        self.markerClickPopups[oldHoveredPoi].setMap(null)
        self.$emit('closedPoiIndex')
      }
      if (self && self.markers && newHoveredPoi >= 0) {
        self.openClickPopup(self, self.pois[newHoveredPoi], newHoveredPoi)
      }
    }
  },
  mounted () {
    const self = this

    self.markerIconPoi.url = require('@/assets/icon-pointmap-marker.png')
    self.markerIconSearch.url = require('@/assets/icon-pointmap-marker-active.png')

    const center = { lat: 48.0532510192798, lng: 12.770071628931637 }
    if (self.latitudeSearched && self.longitudeSearched) {
      center.lat = parseFloat(self.latitudeSearched)
      center.lng = parseFloat(self.longitudeSearched)
    }

    self.map = new google.maps.Map(self.$refs[self.id], {
      center: center,
      scrollwheel: !self.mobile,
      zoom: 13,
      minZoom: null,
      maxZoom: 18,
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      styles: [
        {
          featureType: 'poi',
          stylers: [{ visibility: 'off' }]
        }
      ]
    })

    self.mapBounds = new google.maps.LatLngBounds()
    self.updateSearchMarker()
    if (self.pois.length) {
      self.markers = []
      for (let i = 0; i < self.pois.length; i++) {
        self.addMapMarker(self, self.pois[i], i)
      }
      if (!self.bounds) {
        self.map.fitBounds(self.mapBounds)
      }
    }
  },
  methods: {
    createPopupClass: function () {
      function Popup (position, content) {
        this.position = position
        this.content = content

        // Optionally stop clicks, etc., from bubbling up to the map.
        google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.content)
      }

      // ES5 magic to extend google.maps.OverlayView.
      Popup.prototype = Object.create(google.maps.OverlayView.prototype)

      /** Called when the popup is added to the map. */
      Popup.prototype.onAdd = function () {
        this.getPanes().floatPane.appendChild(this.content)
      }

      /** Called when the popup is removed from the map. */
      Popup.prototype.onRemove = function () {
        if (this.content.parentElement) {
          this.content.parentElement.removeChild(this.content)
        }
      }

      /** Called each frame when the popup needs to draw itself. */
      Popup.prototype.draw = function () {
        const divPosition = this.getProjection().fromLatLngToDivPixel(this.position)

        // Hide the popup when it is far out of view.
        const display =
          Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
            ? 'block'
            : 'none'
        if (display === 'block') {
          this.content.style.left = divPosition.x + 'px'
          this.content.style.top = divPosition.y + 'px'
        }
        if (this.content.style.display !== display) {
          this.content.style.display = display
        }
      }

      return Popup
    },
    updateSearchMarker: function () {
      const self = this
      if (self.searchMarker) {
        self.searchMarker.setMap(null)
      }
      if (self.latitudeSearched && self.longitudeSearched) {
        const LatLng = new google.maps.LatLng(
          parseFloat(self.latitudeSearched),
          parseFloat(self.longitudeSearched)
        )
        self.searchMarker = new google.maps.Marker({
          position: LatLng,
          icon: self.markerIconSearch,
          title: self.$i18n.t('dealersearch.map.searchLocation'),
          map: self.map
        })
        self.searchMarker.addListener('click', function () {
          self.openSearchPopup(self)
        })
        self.mapBounds.extend(LatLng)
      }
    },
    addMapMarker: function (self, poi, index) {
      const LatLng = new google.maps.LatLng(poi.lat, poi.lng)
      self.markers[index] = new google.maps.Marker({
        position: LatLng,
        title: poi.name,
        icon: self.markerIconPoi
      })

      self.markers[index].addListener('click', function () {
        self.$emit('clickedPoiIndex', self.pois.indexOf(poi))
        self.openClickPopup(self, poi, index)
      })

      if (!this.bounds) {
        self.mapBounds.extend(LatLng)
      }
      self.markers[index].setMap(self.map)
    },
    openSearchPopup: function (self) {
      if (!self.searchMarker) return
      const LatLng = self.searchMarker.getPosition()

      const module = document.createElement('div')
      module.classList.add('module-map-popup')
      if (self.mobile) {
        module.classList.add('-mobile')
      }
      const wrapper = document.createElement('div')
      wrapper.classList.add('map-popup-wrapper')
      wrapper.innerHTML = '<div class="map-popup__content">' +
          '<div class="content__name heading epsilon"><span>' + self.$i18n.t('dealersearch.map.searchLocation') + '</span></div>' +
          '</div>'
      module.appendChild(wrapper)
      const close = document.createElement('div')
      close.classList.add('map-popup-close')
      close.addEventListener('click', function () {
        if (self.searchPopup) {
          self.searchPopup.setMap(null)
          self.searchPopup = null
        }
      })
      module.appendChild(close)

      if (self.lastClickedIndex >= 0) {
        self.markerClickPopups[self.lastClickedIndex].setMap(null)
        self.$emit('closedPoiIndex')
      }

      if (self.searchPopup) {
        self.searchPopup.setMap(null)
      }

      const Popup = self.createPopupClass()
      self.searchPopup = new Popup(LatLng, module)
      self.searchPopup.setMap(self.map)
    },
    openClickPopup: function (self, poi, index) {
      const LatLng = new google.maps.LatLng(poi.lat, poi.lng)

      const module = document.createElement('div')
      module.classList.add('module-map-popup')
      if (self.mobile) {
        module.classList.add('-mobile')
      }
      const wrapper = document.createElement('div')
      wrapper.classList.add('map-popup-wrapper')
      wrapper.innerHTML = '<div class="map-popup__content">' +
          '<div class="content__name heading epsilon"><span>' + poi.name + '</span></div>' +
          '<div class="content__street"><span>' + poi.street + '</span></div>' +
          '<div class="content__city"><span>' + poi.zip + ' ' + poi.city + '</span></div>' +
          (poi.website ? '<div class="content__link"><a class="link" href="' + poi.website + '" target="_blank"><span>' + self.$i18n.t('dealersearch.map.popup.button') + '</span></a></div>' : '') +
          '</div>'
      module.appendChild(wrapper)
      const close = document.createElement('div')
      close.classList.add('map-popup-close')
      close.addEventListener('click', function () {
        self.$emit('closedPoiIndex')
        module.parentElement.removeChild(module)
      })
      module.appendChild(close)

      if (self.searchPopup) {
        self.searchPopup.setMap(null)
        self.searchPopup = null
      }

      self.map.addListener('click', function () {
        if (self.searchPopup) {
          self.searchPopup.setMap(null)
          self.searchPopup = null
        }
        if (self.lastClickedIndex >= 0) {
          self.markerClickPopups[self.lastClickedIndex].setMap(null)
          self.$emit('closedPoiIndex')
        }
      })

      if (self.lastClickedIndex >= 0) {
        self.markerClickPopups[self.lastClickedIndex].setMap(null)
        self.$emit('closedPoiIndex')
      }

      if (self.markerClickPopups[index]) {
        self.markerClickPopups[index].setMap(null)
        self.$emit('closedPoiIndex')
      }

      const Popup = self.createPopupClass()
      self.markerClickPopups[index] = new Popup(LatLng, module)

      self.markerClickPopups[index].setMap(self.map)
      self.$emit('clickedPoiIndex', index)
      self.lastClickedIndex = index
      self.skipListeners = false
    }
  }
}
</script>
